<div class="attached-properties">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="fw-semibold">
            @if (totalCount > 0 || !isLoading) {
                {{ totalCount | number }} {{ totalCount === 1 ? 'Property' : 'Properties' }} attached
            } @else {
                Loading properties...
            }
        </div>
        <button type="button" class="btn btn-ms-secondary" (click)="onEditClicked()">
            <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.9" class="me-2" />
            Edit Properties
        </button>
    </div>

    @if (isLoading && count() === 0) {
        <div class="d-flex justify-content-center py-4">
            <span class="spinner-border text-primary" role="status" aria-label="Loading attached properties"></span>
        </div>
    } @else if (count() === 0) {
        <div class="alert alert-info mb-0">
            <fa-duotone-icon icon="circle-info" class="me-2" />
            No properties are currently attached to this invoice schedule.
        </div>
    } @else {
        <div class="list-group">
            @for (property of properties(); track property.propertyId) {
                <div class="list-group-item">
                    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                        <div class="flex-grow-1">
                            <div class="fw-bold">{{ property.title | noValue }}</div>
                            <div class="small text-muted">{{ getPhysicalAddress(property) | noValue }}</div>
                        </div>
                        @if (property.lotNumber) {
                            <div class="small text-muted">
                                <span class="fw-semibold">Lot:</span> {{ property.lotNumber }}
                            </div>
                        }
                    </div>
                </div>
            }
        </div>

        @if (hasNext) {
            <div ms-in-view-port (inViewPort)="loadMoreInView()" class="text-center py-3">
                <span class="spinner-border spinner-border-sm text-primary" role="status" aria-label="Loading more properties"></span>
            </div>
        } @else if (count() > 0) {
            <div class="text-center text-muted small py-3">No more results</div>
        }
    }
</div>
